export type DeviceType = 1 | 2 | 3;

interface IDeviceTypeEnum {
    Terminal: DeviceType;
    DoorScreen: DeviceType;
    InfoScreen: DeviceType;
    format(value: number): string | undefined;
}

const datasource = [{ key: 1, text: 'Terminalas' }, { key: 2, text: 'Durų ekranas' }, { key: 3, text: 'Info ekranas' }];

export const deviceType: IDeviceTypeEnum = {
    Terminal: 1,
    DoorScreen: 2,
    InfoScreen: 3,
    format(value: number) {
        const item = datasource.find(x => x.key === value);
        return item && item.text;
    }
};
